import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import WheatTortillaProduct from 'models/WheatTortillaProduct'
import WheatTortillaPackage from './WheatTortillaPackage'

const productOptions = {
  packagingInfo: <WheatTortillaPackage />,
  productTitle: 'Brand Specific Whole Wheat Tortillas',
  model: WheatTortillaProduct,
  validCategories: ['16'],
  validSubCategories: ['008'],
  brandSpecific: true,
}

const WheatTortilla = () => <ProductForm product={productOptions} />

export default WheatTortilla

export const getWheatTortillaPackage = newProduct => {
  const newWheatTortillaPackage = {
    UPC: newProduct.UPC,
    Size: newProduct.Size,
  }
  return newWheatTortillaPackage
}

export const updateWheatTortillaPackage = newProduct => {
  const newWheatTortillaPackage = {
    UPC: newProduct.UPC,
    Size: newProduct.Size,
  }
  return newWheatTortillaPackage
}
